import { IconNames } from "@shared/enums/icons.enums";
import { SvgIcon } from "../SvgIcon/SvgIcon";
import S from "./PageLoader.module.scss";

interface PageLoaderProps {
    isPageLoading: boolean;
}

export const PageLoader = ({ isPageLoading }: PageLoaderProps) => {
    if (!isPageLoading) return null;

    return (
        <div className={S.blur} role="status" aria-live="polite" aria-label="Loading">
            <div className={S.loader}>
                <SvgIcon iconName={IconNames.HMFloader} />
            </div>
        </div>
    );
};
